import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { connect } from 'react-redux';

import App from './containers/App/App';
import asyncComponent from './helpers/AsyncFunc';
import MaintenancePage from './containers/Page/maintenance';
import Loader from './components/utility/loader';
import { getSystemStatus, MAINTENANCE_EVENT } from './helpers/maintenance';

const RestrictedRoute = ({ component: Component, isLoggedIn, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isLoggedIn ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/signin',
            state: { from: props.location }
          }}
        />
      )
    }
  />
);




class PublicRoutes extends Component {
  state = {
    checkingMaintenance: true,
    maintenance: false,
    retrying: false
  };

  componentDidMount() {
    window.addEventListener(MAINTENANCE_EVENT, this.showMaintenance);
    this.checkMaintenanceStatus();
  }

  componentWillUnmount() {
    window.removeEventListener(MAINTENANCE_EVENT, this.showMaintenance);
  }

  showMaintenance = () => {
    this.setState({
      checkingMaintenance: false,
      maintenance: true,
      retrying: false
    });
  };

  checkMaintenanceStatus = () => {
    this.setState({ checkingMaintenance: true });
    getSystemStatus().then(maintenance => {
      this.setState({
        checkingMaintenance: false,
        maintenance,
        retrying: false
      });
    });
  };

  retryMaintenanceStatus = () => {
    this.setState({ retrying: true });
    getSystemStatus().then(maintenance => {
      this.setState({
        checkingMaintenance: false,
        maintenance,
        retrying: false
      });
    });
  };

  renderRoutes() {
    const { isLoggedIn } = this.props;

    return (
      <div>
        <Route
          exact
          path={'/'}
          isLoggedIn={isLoggedIn}
          component={asyncComponent(() => import('./containers/Page/signin'))}
        />
        <Route
          exact
          path={'/404'}
          component={asyncComponent(() => import('./containers/Page/404'))}
        />
        <Route
          exact
          path={'/500'}
          component={asyncComponent(() => import('./containers/Page/500'))}
        />
        <Route
          exact
          path={'/signin'}
          isLoggedIn={isLoggedIn}
          component={asyncComponent(() => import('./containers/Page/signin'))}
        />
        <Route
          exact
          path={'/forgotpassword'}
          component={asyncComponent(() =>
            import('./containers/Page/forgotPassword')
          )}
        />
        <Route
          exact
          path={'/resetpassword'}
          component={asyncComponent(() =>
            import('./containers/Page/resetPassword')
          )}
        />
        <RestrictedRoute
          path="/dashboard"
          component={App}
          isLoggedIn={isLoggedIn}
        />
      </div>
    );
  }

  render() {
    const { history } = this.props;
    const { checkingMaintenance, maintenance, retrying } = this.state;

    return (
      <ConnectedRouter history={history}>
        {checkingMaintenance ? (
          <Loader />
        ) : maintenance ? (
          <MaintenancePage
            onRetry={this.retryMaintenanceStatus}
            retrying={retrying}
          />
        ) : (
          this.renderRoutes()
        )}
      </ConnectedRouter>
    );
  }
}

export default connect(state => ({
  isLoggedIn: state.Auth.idToken !== null
}))(PublicRoutes);
